export default {
    InstitutionList: require('./InstitutionList').default,
    InstitutionForm: require('./InstitutionForm').default,
    MemberInstitution: require('./MemberInstitution').default
}